/**
 * @generated SignedSource<<3489699a2d3cfbd514f802edc141599f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTableIssueTable$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HeaderCellContainer">;
  readonly " $fragmentType": "IssueTableIssueTable";
};
export type IssueTableIssueTable$key = {
  readonly " $data"?: IssueTableIssueTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTableIssueTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueTableIssueTable",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "HeaderCellContainer"
    }
  ],
  "type": "JiraIssueSearchViewMetadata",
  "abstractKey": "__isJiraIssueSearchViewMetadata"
};

(node as any).hash = "4c9fad0b83db602b39e7619ec2ef4dfb";

export default node;
